<template>
  <p>數值：{{ rangeBarValue }}</p>
  <CFormRange
    :id="id"
    :min="info.extension_info.min"
    :max="info.extension_info.max"
    :model-value="'0'"
    @change="onRangeChange"
  />
  <div class="d-flex justify-content-between">
    <p>{{ info.extension_info.min }}</p>
    <p>{{ info.extension_info.max }}</p>
  </div>
</template>
<script>
import { ref } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const rangeBarValue = ref(String(props.info.extension_info.min))
    const onRangeChange = (e) => {
      rangeBarValue.value = e?.target.value
    }
    return {
      rangeBarValue,
      onRangeChange,
    }
  },
}
</script>
